import { Injectable, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';
import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ApiService } from './api.service';
import { JwtService } from './jwt.service';
import { ContextService } from './context.service';
import { CartService } from './cart.service';
import { User } from '../models';


@Injectable()
export class UserService {

  currentUserSubject = new BehaviorSubject<User>(new User());
  public currentUser = this.currentUserSubject.asObservable().distinctUntilChanged();

  isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();
  context: string;
  // area: string;

  constructor (
    private apiService: ApiService,
    private contextService: ContextService,
    private cartService: CartService,
    private http: Http,
    private jwtService: JwtService,
    private router: Router,
  ) {}

  // Verify JWT in sessionStorage with server & load user's info.
  // This runs once on application startup.
  populate() {
    // If JWT detected, attempt to get & store user's info
    // console.log(this.jwtService.getToken())
    if (this.jwtService.getToken()) {
      this.apiService.get('/utilisateur')
      .subscribe(
        data => {
          data.utilisateur.dateDerniereConnexion = new Date().toLocaleString();
          this.currentUserSubject.next(data.utilisateur);
          this.isAuthenticatedSubject.next(true);

          //this.cartService.diffCarts(true);

          // if(!this.cartService.isEmptyLocalCart()){
          //   let cont = this.contextService.getContext();
          //   let cart = this.cartService.getLocalCart();
          //   cart.lignePanier.forEach( function (l){
          //     let ligne = {
          //       marche: cont,
          //       idOffreCommerciale: l.idOffreCommerciale,
          //       indicateurAdoption: l.indicateurAdoption,
          //       quantite: l.quantite,
          //       idPaysLPC: data.utilisateur.idPaysLPC
          //     };
          //     this.cartService.postLineValidate(ligne).subscribe( data => console.log(data) );
          //   }, this);
          // }
          this.context = this.contextService.getContext();
          let user = data.utilisateur;
          if(this.context == 'B2C'){
             if(user.typeUtilisateur != 305){
              this.router.navigate(['/']);
             }
          } else {
            if(user.typeUtilisateur == 305){
              this.router.navigate(['/familles']);
            }
          }
        },
        err => this.purgeAuth()
      );
    } else {
      // Remove any potential remnants of previous auth states
      this.purgeAuth();
    }
  }


  setAuth(user: User, headers: any = {}) {

    if (headers.has('Authorization')) {
      let token = headers.get('Authorization');
      sessionStorage.setItem('typeUtilisateur', user.typeUtilisateur.toString());

      // Save JWT sent from server in sessionStorage
      this.jwtService.saveToken(token);
    } else {
      this.isAuthenticatedSubject.next(false);
      return;
    }

    // this.router.events.subscribe((ev:any) => {
    //      if (ev instanceof NavigationEnd ) {
    //       let url =ev.url.split("/");
    //       this.context = (url[1] && url[1]=='familles') ? 'B2C':'B2B';
    //       this.contextService.setContext(this.context);
    //       // this.context_root=(this.contextService.getContext()=='B2B')?'':'/familles';
    //     }

    //  });

    this.context = this.contextService.getContext();

    // Set current user data into observable
    user.dateDerniereConnexion = new Date().toLocaleString();
    this.currentUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
// console.log('auth')
    // this.cartService.deleteCart().subscribe(data => console.log('cart deleted'));

    this.cartService.convertLocaltoCart(true, user.idPaysLPC);


    let ressourcesUser=[105,102, 109, 108];
    //console.log(user.typeUtilisateur)
    //console.log(ressourcesUser.indexOf(user.typeUtilisateur))
    if (ressourcesUser.indexOf(user.typeUtilisateur) >= 0) {
      this.router.navigate(['/mes-ressources']);
    }

    if (user.typeUtilisateur === 104) {
      // this.router.navigate(['/mon-compte']);
      let token = headers.get('Authorization');
      token = token.substring(7);
      window.location.href = '/contact-technique?token=' + token;
    }

  }

  purgeAuth() {
    // console.log('purge')
    // this.cartService.destroyCart();
    this.cartService.deleteCart().subscribe(
        data => console.log('cart deleted')
      );
    sessionStorage.setItem('typeUtilisateur', "");
    setTimeout(() => {
      // Remove JWT from sessionStorage
      this.jwtService.destroyToken();

      // Set current user to an empty object
      this.currentUserSubject.next(new User());
      // Set auth status to false
      this.isAuthenticatedSubject.next(false);
      //this.router.navigate(['/familles']);
      this.cartService.destroyLocalCart();

      this.cartService.cartevent.emit('cartchange');

    },1000)




  }

  attemptAuth(type, credentials): Observable<any> {
    // console.log("a")
    return this.apiService.post('/utilisateur/auth', credentials)
    .map(
      data => {
        // console.log("b")
        this.context = this.contextService.getContext();
        let user = data.json().utilisateur;
        if(this.context == 'B2C' && user.typeUtilisateur == 305){
          this.setAuth(user, data.headers);
          return data;
        }
        if(this.context == 'B2B' && user.typeUtilisateur != 305){
          this.setAuth(user, data.headers);
          return data;
        }
        return 'wrong_site';
      },
      error => {
        console.log('Erreur d\'authentification');
      }
    );
  }

  getCurrentUser(): User {
    return this.currentUserSubject.value;
  }

  // Update the user on the server (email, pass, etc)
  update(user: User): Observable<User> {
    return this.apiService
    .put('/utilisateur', user )
    .map(data => {
      // Update the currentUser observable
      this.currentUserSubject.next(data.utilisateur);
      return data.utilisateur;
    });
  }

  create(user): Observable<User> {
    return this.apiService
    .post('/utilisateur', user )
    .map(data => {
      this.currentUserSubject.next(data.utilisateur);
      return data;
    }, error => {
      return error;
    });
  }

  hasNonQuantiteMinimale(user: User): boolean{
    let uais = user.uai;

    uais.forEach(function(data){
      console.log(data)
    }, this);
    return false;
  }

   getAllRessources(): Observable<any>{
    return this.apiService.get('/ressource')
      .map( data => data.ressource );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/user.service.ts